import { createAsyncThunk } from '@reduxjs/toolkit';

const onFetchSnapshot = async ({ timeRange, filter }, { extra: { http } }) => {
  const { recruiters } = filter;
  const params = {
    filter_by: { time_range: {} },
  };

  if (timeRange) {
    params['filter_by']['time_range']['from_ts'] = timeRange?.from;
    params['filter_by']['time_range']['to_ts'] = timeRange?.to;
    params['filter_by']['time_range']['interval'] = timeRange?.defaultInterval;
  }

  if (recruiters) {
    params['filter_by']['users'] = recruiters;
  }

  try {
    const result = await http.get('outreach_dashboard/snapshot', {
      params,
    });
    return result;
  } catch (e) {
    // console.log(e);
  }
};

const onFetchPeerPerformance = async (
  { filter, page },
  { extra: { http } }
) => {
  const { recruiters } = filter;

  const params = {
    filter_by: {},
  };

  if (recruiters) {
    params['filter_by']['users'] = recruiters;
  }
  try {
    const result = await http.get(
      `outreach_dashboard/peer_performance?page=${page}`,
      {
        params,
      }
    );
    return result;
  } catch {}
};

const onFetchRecentOutreaches = async (_payload, { extra: { http } }) => {
  try {
    const result = await http.get('outreach_dashboard/recent_outreaches');
    return result;
  } catch {}
};

export const fetchSnapshot = createAsyncThunk(
  'dashboardSnapshot/snapshot',
  onFetchSnapshot
);

export const fetchPeerPerformance = createAsyncThunk(
  'dashboardSnapshot/peerPerformance',
  onFetchPeerPerformance
);

export const fetchRecentOutreaches = createAsyncThunk(
  'dashboardSnapshot/recentOutreaches',
  onFetchRecentOutreaches
);
